// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".details-container[data-v-e21e8ef6]{display:flex;flex-wrap:wrap}p[data-v-e21e8ef6]{font-size:1.25rem;margin-bottom:0}@media(min-width:768px){p[data-v-e21e8ef6]{font-weight:300}}span[data-v-e21e8ef6]{font-size:1.25rem;padding:0 4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
